export const apiUrl = function() {
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        return 'http://localhost:9000/';
    } else {
        return '/';
    }
}();

export const stripePublicKey = function() {
    if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
        return 'pk_test_51NsB5ZIt1czi0y3H9IUQSO3RtRKTn0fmd4lD8oVOERgY6CPfO6bZrxIWHbGYwgMYOUqFxbYdKEomcFyWQgtYvhEd00xflCwBGB'; // TPO test key
    } else {
        return 'pk_live_51NsB5ZIt1czi0y3HMiOfGsILlISVabK0zcnFOiS6eCFV5GzyqRW6a5GpF43ix3QmSxIzLP4oHra484vk6qxqlwFc00HtqKg4Vy'; // TPO live key
    }
}();
